import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import { PageErrorFragment } from "@saleor/fragments/types/PageErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getPageErrorMessage from "@saleor/utils/errors/page";
import React from "react";
import { useIntl } from "react-intl";

interface PageheaderDateProps {
  data: {
    endDate: string;
    endTime: string;
    startDate: string;
    startTime: string;
    countdown: boolean;
    pcCountdown: boolean;
    mbCountdown: boolean;
    languageOpt: boolean;
    pcRollingDuration: number;
    mbRollingDuration: number;
  };
  disabled: boolean;
  errors: PageErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const PageheaderDates = ({
  data,
  disabled,
  errors,
  onChange
}: PageheaderDateProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(
    ["startDate", "endDate", "pcRollingDuration", "mbRollingDuration"],
    errors
  );

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "New InfoBar Presentation Mode",
            description: "Info Language TimePicker"
          })}
        />
        <CardContent>
          <Button disabled color={"primary"} style={{ width: 100 }}>
            PC
          </Button>
          <ControlledCheckbox
            name="info"
            label={intl.formatMessage({
              defaultMessage: "Info"
            })}
            onChange={undefined}
            checked={true}
            disabled={true}
          />
          <ControlledCheckbox
            name={"pcCountdown" as keyof FormData}
            label={intl.formatMessage({
              defaultMessage: "Time Pickers",
              description: "check to require active to have value"
            })}
            checked={data.pcCountdown}
            onChange={onChange}
            disabled={disabled}
          />
          <ControlledCheckbox
            name={"languageOpt" as keyof FormData}
            label={intl.formatMessage({
              defaultMessage: "Language",
              description: "check to require active to have value"
            })}
            checked={data.languageOpt}
            onChange={onChange}
            disabled={disabled}
          />
          <FormSpacer />

          <Button disabled color={"primary"} style={{ width: 100 }}>
            Mobile
          </Button>

          <ControlledCheckbox
            name="info"
            label={intl.formatMessage({
              defaultMessage: "Info"
            })}
            onChange={undefined}
            checked={true}
            disabled={true}
          />
          <ControlledCheckbox
            name={"mbCountdown" as keyof FormData}
            label={intl.formatMessage({
              defaultMessage: "Time Pickers",
              description: "check to require active to have value"
            })}
            checked={data.mbCountdown}
            onChange={onChange}
            disabled={disabled}
          />
        </CardContent>
      </Card>
      <CardSpacer />
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Info Rolling Duration",
            description: "Info Rolling Duration"
          })}
        />
        <CardContent>
          <Grid variant="uniform">
            <TextField
              disabled={disabled}
              error={!!formErrors.pcRollingDuration}
              helperText={getPageErrorMessage(
                formErrors.pcRollingDuration,
                intl
              )}
              name={"pcRollingDuration" as keyof FormData}
              onChange={onChange}
              label={"PC Rolling Duration"}
              value={data.pcRollingDuration}
              type="number"
              inputProps={{
                min: 0
              }}
              fullWidth
            />
            <TextField
              disabled={disabled}
              error={!!formErrors.mbRollingDuration}
              helperText={getPageErrorMessage(
                formErrors.mbRollingDuration,
                intl
              )}
              name={"mbRollingDuration" as keyof FormData}
              onChange={onChange}
              label={"Mobile Rolling Duration"}
              value={data.mbRollingDuration}
              type="number"
              inputProps={{
                min: 0
              }}
              fullWidth
            />
          </Grid>
        </CardContent>
      </Card>
      <CardSpacer />
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Activity Dates (Optional)",
            description: "time during activity is active, header"
          })}
        />
        <CardContent>
          <Grid variant="uniform">
            <TextField
              disabled={disabled}
              error={!!formErrors.startDate}
              helperText={getPageErrorMessage(formErrors.startDate, intl)}
              name={"startDate" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage(commonMessages.startDate)}
              value={data.startDate}
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              fullWidth
            />
            <TextField
              disabled={disabled}
              error={!!formErrors.startDate}
              helperText={getPageErrorMessage(formErrors.startDate, intl)}
              name={"startTime" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage(commonMessages.startHour)}
              value={data.startTime}
              type="time"
              InputLabelProps={{
                shrink: true
              }}
              fullWidth
            />
          </Grid>
          <FormSpacer />
          <Grid variant="uniform">
            <TextField
              disabled={disabled}
              error={!!formErrors.endDate}
              helperText={getPageErrorMessage(formErrors.endDate, intl)}
              name={"endDate" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage(commonMessages.endDate)}
              value={data.endDate}
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              fullWidth
            />
            <TextField
              disabled={disabled}
              error={!!formErrors.endDate}
              helperText={getPageErrorMessage(formErrors.endDate, intl)}
              name={"endTime" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage(commonMessages.endHour)}
              value={data.endTime}
              type="time"
              InputLabelProps={{
                shrink: true
              }}
              fullWidth
            />
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
export default PageheaderDates;
